export enum ZIndex {
    sectionDivider = 50,
    toolbar = 101,
    assetPreview = 102,
    leftPanel = 150,
    mainBar = 180,
    modal = 1300,
}
